module.exports = __webpack_public_path__ + "static/media/village_home.11b2f915.png";